<div class="w100 col gap-16">
    <div class="w100 row space-between align-center">
        <rr-icon name="error" class="roundicon"></rr-icon>
        <rr-icon name="close" class="close" (click)="close()"></rr-icon>
    </div>
    <div class="col w100 gap-8">
        <h3 i18n>Delete Stream Connections</h3>
        <p>This figma closing is still associated with a generic stream. Please delete the following connections first before deleting the figma closing:</p>

        <div class="w100 card col gap-8" *ngFor="let stream of streams">
            <div class="row space-between w100">
                <div class="col gap-4">
                    <div class="row gap-24 align-center">
                        <h4 class="strong">{{ stream.name }}</h4>
                        <div class="row gap-8">
                            <rr-badge tone="success">{{ stream.status }}</rr-badge>
                            <rr-badge tone="info">{{ stream.type }}</rr-badge>
                        </div>
                    </div>
                    <div class="row gap-8 tiny">
                        <span>Steps: {{ stream.steps?.length || 0 }}</span>
                        <span *ngIf="stream.dateCreate">|</span>
                        <span *ngIf="stream.dateCreate"
                            >created:
                            {{ stream.dateCreate | getLocaldateByTime }}</span
                        >
                        <span *ngIf="stream.dateUpdate">|</span>
                        <span *ngIf="stream.dateUpdate"
                            >updated:
                            {{ stream.dateUpdate | getLocaldateByTime }}</span
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>